/**
 * Capitalizes the first letter of a string
 * @param str - The string to capitalize
 * @returns The string with the first letter capitalized
 */
export const capitalizeFirstLetter = (str: string): string => {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1);
};

/**
 * Formats a status string by capitalizing the first letter of each word
 * Handles hyphenated status values like "in-progress" -> "In-progress"
 * @param status - The status string to format
 * @returns The formatted status string
 */
export const formatStatus = (status: string): string => {
  if (!status) return status;
  // Handle hyphenated status like "in-progress" -> "In-progress"
  return status
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join('-');
};
